<template>
  <div class="bubble">
    <span class="text">{{ text }}</span>
    <span class="delete" @click="$emit('delete')">x</span>
  </div>
</template>

<script>
export default {
  name: 'BubbleText',
  props: {
    text: { default: '', type: String },
    showDeleteButton: { default: true, type: Boolean }
  }
}
</script>

<style scoped>
.bubble {
  background-color: #0089cd;
  border: 1px solid black;
  border-radius: 4px;
  margin: 1px;
  width: auto;
}

.text {
  font-size: .8em;
  color: white;
}

.delete {
  font-weight: bold;
  padding-left: 5%;
  color: #43dbae;
}
</style>